export default __webpack_public_path__ + "static/media/19-idea-napkin.3c710026.svg";